import FileInfo from '../containers/FileInfo';

async function listExperimentRootItems(e_id: number) {
  const path = '/api/asebi/experiments/{e_id}/children'.replace('{e_id}', e_id.toString());
  const resp = await fetch(path);
  const json = await resp.json();

  return json.map((data: any) => {
    const f = new FileInfo();
    f.load(data);
    return f;
  });
}

export default listExperimentRootItems;
